<template>
    <div class="user-products">
        <el-row class="section">
            <el-col :span="24">
                <el-tabs type="border-card" v-model="currentTab">
                    <el-tab-pane name="userProducts">
                        <span slot="label">专题商品</span>
                        <el-row class="">
                            <el-collapse accordion v-model="activeNames">
                                <el-collapse-item name="1">
                                    <template slot="title">
                                        <div class="title">
                                            <div @click.stop class="opt-area">
                                                <span style="width: 180px">选择专题：</span>
                                                <el-select v-model="currentSelect" placeholder="请选择专题"
                                                           style="width:45.5%;">
                                                    <el-option
                                                            v-for="item in categories"
                                                            :key="item.id"
                                                            :label="item.name"
                                                            :value="item.id">
                                                    </el-option>
                                                </el-select>
                                                <el-button type="success" size="medium" style="margin-left: 10px"
                                                           @click="showNewPanel">
                                                    {{ activeNames.length > 0 ? '收起' : '新增商品' }}
                                                </el-button>
                                                <a target="_blank"
                                                   href="https://www.yuque.com/yifakeji/irpssl/hlh0km"
                                                   style="margin-left: 5px;color: #ff0036;">不懂点击看文档</a>
                                            </div>
                                        </div>
                                    </template>
                                    <el-row>
                                        <el-col :span="24">
                                            <el-alert
                                                    close-text="知道了"
                                                    type="success">
                                                <p>
                                                    专题最多20个，如果下拉没有找到专题，可以将之前不用的专题进行编辑重复利用</p>
                                            </el-alert>
                                        </el-col>
                                    </el-row>
                                    <el-form :label-position="labelPosition" ref="item-form" :model="item"
                                             :rules="rules"
                                             label-width="180px">
                                        <el-form-item label="商品链接:" prop="keyword">
                                            <el-col :span="12">
                                                <el-input :span="6" placeholder="输入商品链接或者淘口令"
                                                          v-model="keyword"></el-input>
                                            </el-col>
                                            <el-col :span="4">
                                                <el-button type="primary" size="medium" style="margin-left: 10px"
                                                           @click="searchOpenProduct">获取数据
                                                </el-button>
                                            </el-col>
                                        </el-form-item>
                                        <el-form-item label="商品Id:" prop="openId">
                                            <el-col :span="12">
                                                <el-input type="text" autosize v-model="item.openId"></el-input>
                                            </el-col>
                                        </el-form-item>
                                        <el-form-item label="商品标题:" prop="name">
                                            <el-col :span="12">
                                                <el-input type="textarea" autosize v-model="item.name"></el-input>
                                            </el-col>
                                        </el-form-item>
                                        <el-form-item label="商品文案:">
                                            <el-col :span="12">
                                                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}"
                                                          v-model="item.introduce"></el-input>
                                            </el-col>
                                        </el-form-item>
                                        <el-form-item label="商品图片" prop="pics">
                                            <el-col :span="12">
                                                <el-checkbox-group v-model="choosedPics" @change="choosePic"
                                                                   class="group">
                                                    <div class="pic-item-4"
                                                         v-for="(pic,index) in item.smallPictureUrls">
                                                        <div class="pic-item-box">
                                                            <el-popover
                                                                    placement="right"
                                                                    trigger="hover"
                                                                    width="300"
                                                                    :ref="'popover-' + index">
                                                                <img :src="pic"
                                                                     style="width: 400px"/>
                                                                <img slot="reference" :src="pic">
                                                            </el-popover>
                                                        </div>
                                                        <div class="opt">
                                                            <div class="btn-item">
                                                                <el-button size="mini" type="primary"
                                                                           @click.prevent="movePicUp(item,index)">上移
                                                                </el-button>
                                                            </div>
                                                            <div class="btn-item">
                                                                <el-button size="mini" type="success"
                                                                           @click.prevent="toPicTop(item,index)">
                                                                    置顶
                                                                </el-button>
                                                            </div>
                                                        </div>
                                                        <el-checkbox :label="pic" :key="pic">{{
                                                            index + 1
                                                            }}
                                                        </el-checkbox>
                                                    </div>
                                                </el-checkbox-group>
                                                <el-input v-mode="item.pics" v-show="false"></el-input>
                                            </el-col>
                                            <el-col :span="24">
                                                <el-alert
                                                        close-text="知道了"
                                                        type="success">
                                                    <p class="alter-text">
                                                        通过置顶和上移改变商品图片顺序，用户端展示的时候按照顺序展示，第一张图是主图</p>
                                                    <p class="alter-text">鼠标悬停小图，可以自动放大图片</p>
                                                </el-alert>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-input
                                                    type="input"
                                                    class="col-item-7"
                                                    placeholder="请输入图片地址"
                                                    v-model="newAddedPicUrl">
                                                </el-input>
                                            </el-col>
                                            <el-col :span="4">
                                                <el-button class="opt" type="primary" size="small"
                                                           @click="addPic">
                                                    加一张图片
                                                </el-button>
                                            </el-col>
                                        </el-form-item>
                                        <el-form-item label="是否使用礼金" prop="tljUse">
                                            <el-col :span="12">
                                                <el-switch v-model="item.tljUse"></el-switch>
                                            </el-col>
                                            <el-col :span="24">
                                                <el-alert
                                                        close-text="知道了"
                                                        type="success">
                                                    <p class="alter-text">勾选后，此商品将使用礼金</p>
                                                </el-alert>
                                            </el-col>
                                        </el-form-item>
                                        <el-form-item label="礼金创建方式:" prop="tljCreateType"
                                                      v-if="item.tljUse && (item.openProductType=='TAOBAO'||item.openProductType == 'TMALL' || item.openProductType == 'JD')">
                                            <el-col :span="12">
                                                <el-radio-group v-model="item.tljCreateType">
                                                    <el-radio border label="previous">事先创建</el-radio>
                                                    <el-radio border label="realtime"
                                                              v-if="item.openProductType=='TAOBAO'||item.openProductType=='TMALL'">
                                                        实时创建
                                                    </el-radio>
                                                </el-radio-group>
                                            </el-col>
                                            <el-col :span="24">
                                                <el-alert
                                                        close-text="知道了"
                                                        type="success">
                                                    <p class="alter-text">
                                                        事先创建：需要事先就创建好礼金，用户领取的时候，从事先创建的礼金中获取</p>
                                                    <p class="alter-text">
                                                        实时创建：实时创建用户领取的时候，实时创建礼金,这种方式不用事先创建，但是热门商品，可能礼金创建失败，热门商品建议事先创建</p>
                                                    <p class="alter-text" style="color: #ff0036">
                                                        选择实时创建以后，要在【营销管理-淘礼金-appKey管理】的菜单开启：实时礼金appkey开关-</p>
                                                </el-alert>
                                            </el-col>
                                        </el-form-item>
                                        <el-form-item label="实时淘礼金类型:" v-if="item.tljCreateType=='realtime'">
                                            <el-row>
                                                <el-col :span="12">
                                                    <el-radio-group v-model="item.tljUseMode">
                                                        <el-radio border :label="'ONE_DAY'">24小时</el-radio>
                                                        <el-radio border :label="'TODAY_END'">当天结束</el-radio>
                                                    </el-radio-group>
                                                </el-col>
                                                <el-col :span="24">
                                                    <el-alert
                                                            type="success"
                                                            close-text="知道了">
                                                        <p class="alter-text">支持两种类型：</p>
                                                        <p class="alter-text">
                                                            24小时：淘礼金发放和使用结束时间是创建时间顺延24小时</p>
                                                        <p class="alter-text">
                                                            当天结束：淘礼金发放和使用结束时间都是当天的23:59:59</p>
                                                    </el-alert>
                                                </el-col>
                                            </el-row>
                                        </el-form-item>
                                        <el-form-item label="礼金类型:" prop="taolijinType"
                                                      v-if="item.tljUse&&item.tljCreateType == 'previous'">
                                            <el-col :span="12">
                                                <el-radio-group v-model="item.taolijinType">
                                                    <el-radio border label="COMMON">普通</el-radio>
                                                    <el-radio border label="USER_ONLY">防盗</el-radio>
                                                </el-radio-group>
                                            </el-col>
                                            <el-col :span="24">
                                                <el-alert
                                                        close-text="知道了"
                                                        type="success">
                                                    <p class="alter-text">防盗{{
                                                        ljName(item)
                                                        }}主要用于防止同行撸礼金</p>
                                                </el-alert>
                                            </el-col>
                                        </el-form-item>
                                        <el-form-item :label="'选择'+ljName(item)" prop="perFaceYuan"
                                                      v-if="item.tljCreateType == 'previous' && item.taolijinType &&item.tljUse">
                                            <el-col :span="24">
                                                <el-table
                                                        :data="taolijins"
                                                        :width="180"
                                                        highlight-current-row
                                                        @current-change="chooseTableItem"
                                                        border>
                                                    <el-table-column
                                                            label="名称"
                                                            prop="name"
                                                            width="180">
                                                    </el-table-column>
                                                    <el-table-column
                                                            label="商品id"
                                                            prop="itemId"
                                                            width="150">
                                                    </el-table-column>
                                                    <el-table-column
                                                            label="商品信息"
                                                            width="250">
                                                        <template slot-scope="scope">
                                                            <div class="cell-item-img">
                                                                <el-popover
                                                                        placement="right"
                                                                        trigger="hover"
                                                                        width="300"
                                                                        :title="scope.row.productName"
                                                                        :ref="'popover-' + scope.row.id">
                                                                    <a :href="hrefUrl(scope.row)" target="_blank">
                                                                        <img :src="scope.row.productPicUrl"
                                                                             v-show="scope.row.productPicUrl"
                                                                             style="width: 300px;height:300px"/>
                                                                    </a>
                                                                    <img slot="reference" :src="scope.row.productPicUrl"
                                                                         v-show="scope.row.productPicUrl"
                                                                         class="media-image"/>
                                                                </el-popover>
                                                                <a :href="hrefUrl(scope.row)" target="_blank">
                                                                    {{ scope.row.productName }}</a>
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            label="创建时间"
                                                            prop="createTime"
                                                            width="180">
                                                    </el-table-column>
                                                    <el-table-column
                                                            label="淘口令"
                                                            prop="taoToken"
                                                            v-if="item.openProductType == 'TAOBAO'||item.openProductType == 'TMALL'"
                                                            width="180">
                                                    </el-table-column>
                                                    <el-table-column
                                                            label="口令"
                                                            prop="giftCouponKey"
                                                            v-if="item.openProductType == 'JD'"
                                                            width="180">
                                                    </el-table-column>
                                                    <el-table-column
                                                            label="总个数"
                                                            prop="totalNum"
                                                            width="80">
                                                    </el-table-column>
                                                    <el-table-column
                                                            label="单用户累计中奖次数上限"
                                                            prop="userTotalWinNumLimit"
                                                            width="180">
                                                    </el-table-column>
                                                    <el-table-column
                                                            label="面额"
                                                            prop="perFaceYuan"
                                                            width="180">
                                                    </el-table-column>
                                                    <el-table-column
                                                            label="广告位id"
                                                            prop="adzoneId"
                                                            width="180">
                                                    </el-table-column>
                                                    <el-table-column
                                                            label="淘礼金id"
                                                            prop="rightsId"
                                                            width="320">
                                                    </el-table-column>
                                                    <el-table-column
                                                            label="领取链接"
                                                            prop="sendUrl"
                                                            width="180">
                                                    </el-table-column>
                                                    <el-table-column
                                                            label="类型"
                                                            prop="taolijinTypeDesc">
                                                    </el-table-column>
                                                    <el-table-column
                                                            label="发放开始时间"
                                                            prop="sendStartTime"
                                                            width="180">
                                                    </el-table-column>
                                                    <el-table-column
                                                            label="发放结束时间"
                                                            prop="sendEndTime"
                                                            width="180">
                                                    </el-table-column>
                                                    <el-table-column
                                                            label="使用开始时间"
                                                            prop="useStartTime"
                                                            width="180">
                                                    </el-table-column>
                                                    <el-table-column
                                                            label="使用结束时间"
                                                            prop="useEndTime"
                                                            width="180">
                                                    </el-table-column>
                                                    <el-table-column
                                                            label="专题名称"
                                                            prop="upcName"
                                                            width="180">
                                                    </el-table-column>
                                                    <el-table-column
                                                            label="结束日期的模式"
                                                            prop="useEndTimeMode"
                                                            width="180">
                                                        <template slot-scope="scope">
                                                            {{ endTimeMode(scope.row.useEndTimeMode) }}
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            label="解冻金额"
                                                            prop="unfreezeAmount"
                                                            width="180">
                                                    </el-table-column>
                                                    <el-table-column
                                                            label="解冻红包个数"
                                                            prop="unfreezeNum"
                                                            width="180">

                                                    </el-table-column>
                                                    <el-table-column
                                                            label="失效回退金额"
                                                            prop="refundAmount"
                                                            width="180">

                                                    </el-table-column>
                                                    <el-table-column
                                                            label="失效回退红包个数"
                                                            prop="refundNum"
                                                            width="180">

                                                    </el-table-column>
                                                    <el-table-column
                                                            label="引导成交金额"
                                                            prop="alipayAmount"
                                                            width="180">

                                                    </el-table-column>
                                                    <el-table-column
                                                            label="红包核销金额"
                                                            prop="useAmount"
                                                            width="180">

                                                    </el-table-column>
                                                    <el-table-column
                                                            label="红包核销个数"
                                                            prop="useNum"
                                                            width="180">

                                                    </el-table-column>
                                                    <el-table-column
                                                            label="红包领取金额"
                                                            prop="winAmount"
                                                            width="180">

                                                    </el-table-column>
                                                    <el-table-column
                                                            label="红包领取个数"
                                                            prop="winNum"
                                                            width="180">

                                                    </el-table-column>
                                                    <el-table-column
                                                            label="引导预估佣金金额"
                                                            prop="preCommissionAmount"
                                                            width="180">

                                                    </el-table-column>
                                                </el-table>
                                                <div class="empty" style="color: #ff0036;">
                                                    <a :href="((item.openProductType=='TAOBAO' || item.openProductType=='TMALL')? '/new/taoke_tools.html':'/new/jd_lijin.html')+'#/?itemId='+item.openId+'&upcId='+currentSelect+'&taolijinType='+item.taolijinType"
                                                       target="_blank">{{
                                                        taolijins.length == 0 ? '还没有礼金，点击创建礼金' : '创建更多礼金'
                                                        }}</a>
                                                    <el-button size="mini" @click="loadTaolijins" type="success"
                                                               style="margin-left: 10px">加载淘礼金
                                                    </el-button>
                                                </div>
                                                <div class="pagination">
                                                    <el-pagination
                                                            background
                                                            @current-change="handleTljCurrentChange"
                                                            :current-page.sync="tljPage"
                                                            :page-size="pageSize"
                                                            layout="total,prev, pager, next"
                                                            :total="tljTotalCount">
                                                    </el-pagination>
                                                </div>
                                                <el-input v-show="false" v-model.number="item.perFaceYuan"></el-input>
                                            </el-col>
                                        </el-form-item>

                                        <el-form-item :label="'实时创建'+ljName(item)+'比例:'" prop="tljCreateRate"
                                                      v-if="item.tljCreateType == 'realtime'">
                                            <el-col :span="12">
                                                <el-input v-model="item.tljCreateRate"></el-input>
                                            </el-col>
                                            <el-col :span="24">
                                                <el-alert
                                                        close-text="知道了"
                                                        type="success">
                                                    <p class="alter-text">
                                                        {{
                                                        ljName(item)
                                                        }}最低1元创建，低于1元创建失败，此商品最低{{ ljName(item) }}比例为:<span
                                                            class="warning">{{ minTljCreateRate }}</span></p>
                                                    <p class="alter-text">
                                                        实时创建{{
                                                        ljName(item)
                                                        }}的时候，指定一个比例，会根据总佣金的乘以你设置的百分比得到{{
                                                        ljName(item)
                                                        }}金额</p>
                                                </el-alert>
                                            </el-col>
                                        </el-form-item>
                                        <el-form-item label="是否是首单礼金商品" prop="sdljUse"
                                                      v-if="item.openProductType == 'TAOBAO'||item.openProductType == 'TMALL'">
                                            <el-col :span="12">
                                                <el-switch v-model="item.sdljUse"></el-switch>
                                            </el-col>
                                            <el-col :span="24">
                                                <el-alert
                                                        close-text="知道了"
                                                        type="success">
                                                    <p class="alter-text">只有开启{{
                                                        ljName(item)
                                                        }}以后，才能选择首单礼金</p>
                                                    <p class="alter-text">{{ ljName(item) }}用来锁佣</p>
                                                </el-alert>
                                            </el-col>
                                        </el-form-item>
                                        <el-form-item label="首单礼金金额:" prop="sdljCountYuan"
                                                      v-if="item.sdljUse">
                                            <el-col :span="12">
                                                <el-input v-model="item.sdljCountYuan" @input="change"></el-input>
                                            </el-col>
                                        </el-form-item>
                                        <el-form-item label="返利金额:" v-if="currentCategory.upcType == 'FREE_ORDER'">
                                            <el-col :span="12">
                                                <el-input v-model="item.customRebateCount" @input="change"></el-input>
                                            </el-col>
                                            <el-col :span="24">
                                                <el-alert
                                                        type="success"
                                                        close-text="知道了">
                                                    <p class="alter-text">
                                                        对于免单的专题，可以自定义返利金额，系统会自动使用设置的返利金额，忽略设置的返利规则</p>
                                                </el-alert>
                                            </el-col>
                                        </el-form-item>
                                        <el-form-item label="券后价:">
                                            <el-col :span="12">
                                                <el-input v-model="item.priceYuan" @input="change"></el-input>
                                            </el-col>
                                        </el-form-item>
                                        <el-form-item label="佣金比率:">
                                            <el-col :span="12">
                                                <el-input v-model="item.commissionRate"></el-input>
                                            </el-col>
                                        </el-form-item>
                                        <el-form-item label="优惠券:">
                                            <el-col :span="12">
                                                <el-input disabled="" v-model="item.couponPriceYuan"></el-input>
                                            </el-col>
                                        </el-form-item>
                                        <el-form-item label="月销量:">
                                            <el-col :span="12">
                                                <el-input disabled="" v-model="item.monthCount"></el-input>
                                            </el-col>
                                        </el-form-item>
                                        <el-form-item>
                                            <el-col :span="12">
                                                <el-button type="primary" size="medium" @click="onSubmit('item-form')">
                                                    加入专题
                                                </el-button>
                                            </el-col>
                                        </el-form-item>
                                    </el-form>

                                </el-collapse-item>
                            </el-collapse>
                        </el-row>
                        <el-row class="" v-if="categories.length>0">
                            <el-col :span="24" v-loading="loading">
                                <div class="grid-content bg-purple-dark group">
                                    <div class="opt-area" style="display: none">
                                        <div class="title">专题：</div>
                                        <div class="">
                                        <span v-for="category in categories"
                                              class="category-tag">{{ category.name }}</span>
                                        </div>
                                    </div>
                                    <el-col :span="6" class="product-cell" v-for="(product,index) in items"
                                            :key="product.id">
                                        <div class="product-detail" :class="product.openProductType">
                                            <div class="product-pics showVideo?'show-video':''">
                                                <img class="product-pic" mode="widthFix"
                                                     :src="product.mainPictureUrl" @click="goToDetail(product)"></img>
                                                <div class="operation">
                                                    <div class="item">
                                                        <el-button size="mini" type="success"
                                                                   @click.prevent="edit(product)">
                                                            编辑
                                                        </el-button>
                                                    </div>
                                                    <div class="item">
                                                        <el-button size="mini" type="primary"
                                                                   @click.prevent="moveUp(product,index)">上移
                                                        </el-button>
                                                    </div>
                                                    <div class="item">
                                                        <el-button size="mini" type="success"
                                                                   @click.prevent="toTop(product,index)">
                                                            置顶
                                                        </el-button>
                                                    </div>
                                                    <div class="item">
                                                        <el-popover
                                                                placement="top"
                                                                width="160"
                                                                v-model="product.visible">
                                                            <p>确定删除吗？</p>
                                                            <div style="text-align: right; margin: 0">
                                                                <el-button size="mini" type="text"
                                                                           @click="product.visible = false">取消
                                                                </el-button>
                                                                <el-button type="danger" size="mini"
                                                                           @click="deleteProduct(product,index)">确定
                                                                </el-button>
                                                            </div>
                                                            <el-button slot="reference" type="danger" size="mini">删除
                                                            </el-button>
                                                        </el-popover>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="detail-info">
                                                <div class="title-box">
                                                    <div class="h1">
                                                        <!--<svg class="iconfont" aria-hidden="true">
                                                            <use :xlink:href="'#'+Common.iconClass(product)"></use>
                                                        </svg>-->
                                                        <i :class="'iconfont '+ Common.iconClass(product)"></i>
                                                        <span>{{ product.name }}</span>
                                                    </div>
                                                </div>
                                                <div class="product-price group">
                                                    <div class="price-tag">优惠券</div>
                                                    <div class="price" data-prefix="￥">{{
                                                        product.couponPrice / 100
                                                        }}
                                                    </div>

                                                    <div class="rebate-price" v-if="product.monthCount">
                                                        <div class="price-tag">月售</div>
                                                        <div class="price">{{ product.monthCount }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="detail-box">
                                                <div class="item">
                                                    <div class="text">{{ product.price / 100 }}</div>
                                                    <div class="tag">{{ Common.priceTag(product) }}</div>
                                                </div>
                                                <div class="item">
                                                    <div class="text">{{ product.commissionRate }}%</div>
                                                    <div class="tag">佣金比率</div>
                                                </div>
                                                <div class="item">
                                                    <div class="text">{{ product.effectEstimate.toFixed(2) }}</div>
                                                    <div class="tag">佣金</div>
                                                </div>
                                                <div class="item"
                                                     v-if="product.tljCreateRate&&product.tljCreateType=='realtime'&&product.tljUse">
                                                    <div class="text">{{ product.tljCreateRate }}</div>
                                                    <div class="tag">{{ ljName(product) }}比例</div>
                                                </div>
                                                <div class="item"
                                                     v-if="product.perFace&&product.tljCreateType=='previous'&&product.tljUse">
                                                    <div class="text">{{ product.perFace / 100 }}</div>
                                                    <div class="tag">{{ ljName(product) }}金额</div>
                                                </div>
                                            </div>
                                            <div class="recommend">
                                                <div class="tag">
                                                </div>
                                                <div class="word" catchtap="copyIntroduce" data-index="index"
                                                     v-html="introduceHtml(product)">
                                                </div>
                                            </div>
                                        </div>

                                    </el-col>
                                </div>
                            </el-col>
                            <el-col :span="24">
                                <div class="pagination">
                                    <el-pagination
                                            background
                                            @current-change="handleCurrentChange"
                                            :current-page.sync="page"
                                            :page-size="pageSize"
                                            layout="total,prev, pager, next"
                                            :total="totalCount">
                                    </el-pagination>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row style="text-align: center" v-else>
                            <el-col :span="24">
                                未创建专题，请先创建专题。
                                <el-button type="success" size="medium" @click="currentTab='userProductCategories'">
                                    创建专题
                                </el-button>
                            </el-col>
                        </el-row>

                    </el-tab-pane>
                    <el-tab-pane label="专题列表" name="userProductCategories">
                        <category_list v-if="currentTab == 'userProductCategories'"></category_list>
                    </el-tab-pane>
                </el-tabs>

            </el-col>
        </el-row>


    </div>

</template>
<script>

import {openProductApi} from "../../common/openProductApi";
import {userProductApi} from "../../common/userProductApi";
import {userProductCategoryApi} from "../../common/userProductCategoryApi";
import {taobaoApi} from "../../common/taobaoApi";
import {jdApi} from "../../common/jdApi";


export default {
    name: "index",
    components: {
        category_list: require('./category_list').default,

    },
    data() {
        var validateTljCreateRate = (rule, value, callback) => {
            let effectEstimate = ((this.item.commissionRate / 100) * this.item.price / 100).toFixed(2);
            if (effectEstimate < 1) {
                this.failMsg("此商品不适合实时创建淘礼金，佣金低于1元")
                callback(new Error("此商品不适合实时创建淘礼金，佣金低于1元"));
            } else {

            }
            let minRate = ((1 / effectEstimate) * 100).toFixed(2);

            if (!value) {
                callback(new Error("请填写创建礼金比例"));
                this.failMsg("请填写创建礼金比例");
            } else if (parseFloat(value.replace('%', '')) < minRate) {
                callback(new Error("比例最低不能低于:" + minRate));
                this.failMsg("比例最低不能低于" + minRate);
            } else {
                callback();
            }
        };
        return {
            activeNames: [],
            loading: false,
            labelPosition: 'left',
            currentTab: 'userProducts',
            currentSelect: '',
            keyword: '',
            page: 1,
            pageSize: 20,
            totalCount: 0,
            tljPage: 1,
            tljTotalCount: 0,
            categories: [],
            catsMap: {},
            currentCategory: {},
            item: {
                tljCreateType: 'previous',
                perFaceYuan: null,
                perFace: '',
                tljUse: false,
                pics: [],
            },
            choosedPics: [],
            newAddedPicUrl: '',
            items: [],
            taolijins: [],
            editImg: false,
            rules: {
                mainPictureUrl: [
                    {required: true, message: '请输入图片链接', trigger: 'blur'},
                ],
                name: [
                    {required: true, message: '请输入商品标题', trigger: 'blur'},
                ],
                tljCreateRate: [
                    {
                        required: true,
                        validator: validateTljCreateRate,
                        message: '请输入正确的礼金佣金比例', trigger: 'blur'
                    },
                ],
                tljCreateType: [
                    {required: true, message: '请选择礼金创建类型', trigger: 'change'},
                ],
                taolijinType: [
                    {required: true, message: '请选择礼金类型', trigger: 'change'},
                ],
                sdljCountYuan: [
                    {required: true, message: '请输入首单礼金金额', trigger: 'change'},
                ],
                perFaceYuan: [
                    {
                        required: true,
                        message: '请选择礼金',
                        validator: (rule, value, callback) => {
                            if (!this.item.perFaceYuan) {
                                callback(new Error("请选择礼金"));
                                this.failMsg("请选择礼金")
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change'
                    },
                ],
                pics: [
                    {
                        required: true,
                        message: '请选择图片',
                        validator: (rule, value, callback) => {
                            console.log(this.choosedPics)
                            if (!this.choosedPics || this.choosedPics.length == 0) {
                                callback(new Error("请选择图片"));
                                this.failMsg("请选择图片")
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change'
                    },
                ],
                openId: [
                    {required: true, message: '请输入商品Id', trigger: 'blur'},
                    {min: 5, max: 100, message: '长度在 5 到 100 个字符', trigger: 'blur'}
                ]
            },


        }
    },

    computed: {
        minTljCreateRate: function () {
            let effectEstimate = ((this.item.commissionRate / 100) * this.item.price / 100).toFixed(2);
            if (effectEstimate > 1) {
                let minRate = ((1 / effectEstimate) * 100).toFixed(2);
                return minRate;
            }
        },

        introduceHtml() {
            return (item) => {
                return item.introduce ? item.introduce.replace(/(\r\n)|(\n)/g, "<br>") : '未设置文案';
            }
        },

        ljName() {
            return (item) => {
                return (item.openProductType == 'TAOBAO' || item.openProductType == 'TMALL') ? '淘礼金' : (item.openProductType == 'JD' ? '京享礼金' : '');
            }
        }

    },
    watch: {
        currentSelect(newValue, oldValue) {
            var that = this
            that.page = 1;
            that.totalCount = 0;
            that.items = []
            that.loading = true
            that.currentCategory = that.catsMap[newValue]
            userProductApi.getUserProducts.call(that, {
                    categoryId: newValue,
                    page: that.page,
                    pageSize: that.pageSize
                }, function (res) {
                    if (res.result.items) {
                        that.items = res.result.items;
                        that.totalCount = res.result.totalCount;
                    }
                    that.loading = false

                }, function (res) {
                    that.loading = false;
                }
            )
        },
        'item.tljCreateType': {
            handler: function () {
                console.log(this.item.tljCreateType)
            }
        },

        'item.taolijinType': {
            handler: function () {
                this.loadTaolijins();
            }
        },
    },
    mounted() {


    },

    created() {
        var that = this
        userProductCategoryApi.getUserProductCategories.call(that, {}, function (res) {
            if (res.result.items && res.result.items.length > 0) {
                var items = []
                for (let i = 0; i < res.result.items.length; i++) {
                    let item = res.result.items[i];
                    if (item.upcType != 'INVITE') {
                        items.push(item)
                        that.catsMap[item.id] = item
                    }
                }
                that.categories = items;
                that.currentSelect = items[0].id

            }

        })

    },
    methods: {
        loadTaolijins() {
            var that = this;
            that.tljPage = 1
            var data = {
                page: this.tljPage,
                pageSize: this.pageSize,
                itemId: this.item.openId,
                upcId: this.currentSelect
            }
            if (this.item.taolijinType === 'COMMON') {
                data.taolijinType = 'COMMON'
            } else if (this.item.taolijinType === 'USER_ONLY') {
                data.taolijinType = 'USER_ONLY'
                data.onlyNext = true //对于防盗类型的口令，只需要获取下一个防盗类型口令即可
            } else {
                return
            }
            if (that.item.openProductType == "JD") {
                jdApi.getLijins.call(that, data, function (res) {
                    if (res.result.data) {
                        that.taolijins = res.result.data
                    }
                    if (res.result.totalCount) {
                        that.tljTotalCount = res.result.totalCount
                    }
                });
            } else {
                taobaoApi.getTaoLijins.call(that, data, function (res) {
                    if (res.result.data) {
                        that.taolijins = res.result.data
                    }
                    if (res.result.totalCount) {
                        that.tljTotalCount = res.result.totalCount
                    }
                });
            }

        },
        chooseTableItem(row) {
            var that = this
            this.item.perFace = row.perFace;
            if (that.item.openProductType == 'JD') {
                this.item.taoToken = row.giftCouponKey;
            } else {
                if (this.item.taolijinType == 'COMMON') {
                    this.item.taoToken = row.taoToken;
                }
            }

            if (that.item.perFace) {
                that.item.perFaceYuan = (that.item.perFace / 100)
                that.$forceUpdate()
            }
        },
        detailUrl(item) {
            if (item.openProductType == 'TAOBAO' || item.openProductType == 'TMALL') {
                if (item.fullId) {
                    return "https://uland.taobao.com/item/edetail?id=" + item.fullId;
                } else {
                    return "https://item.taobao.com/item.htm?id=" + (item.itemId ? item.itemId : item.openId);
                }
            } else if (item.openProductType == 'JD') {
                return item.fullId;
            } else if (item.openProductType == 'PDD') {
                return "https://mobile.yangkeduo.com/goods2.html?goods_id=" + item.openId.replace("PDD", "");
            }
            return "";
        },
        hrefUrl(item) {
            if (item.openProductType == 'TAOBAO' || item.openProductType == 'TMALL') {
                if (item.fullId) {
                    return "https://uland.taobao.com/item/edetail?id=" + item.fullId;
                } else {
                    return "https://item.taobao.com/item.htm?id=" + (item.itemId ? item.itemId : item.openId);
                }
            } else if (item.openProductType == 'JD') {
                return "https://item.jd.com/" + (item.itemId ? item.itemId.replace("JD", "") : item.openId.replace("JD", "") + ".html");
            } else if (item.openProductType == 'PDD') {
                return "https://jinbao.pinduoduo.com/goods-detail?s=" + item.openId.replace("PDD", "");
            }
            return "";
        },
        endTimeMode(mode) {
            if (mode == 1) {
                return "相对时间"
            } else {
                return "绝对时间"
            }
        },

        handleTljCurrentChange() {
            var that = this
            var data = {
                page: this.tljPage,
                pageSize: this.pageSize,
                itemId: this.item.openId
            }
            if (this.item.taolijinType === 'COMMON') {
                data.taolijinType == 'COMMON'
            } else if (this.item.taolijinType === 'USER_ONLY') {
                data.taolijinType == 'USER_ONLY'
            } else {
                return
            }
            taobaoApi.getTaoLijins.call(that, data, function (res) {
                if (res.result.data) {
                    that.taolijins = res.result.data
                }
                if (res.result.totalCount) {
                    that.tljTotalCount = res.result.totalCount
                }
            })
        },

        searchOpenProduct() {
            var that = this;
            openProductApi.getOpenProduct.call(that, {keyword: that.keyword, containPics: true}, function (res) {
                    if (res.result.item) {
                        that.item = res.result.item;
                        if (!that.item.smallPictureUrls) {
                            that.item.smallPictureUrls = []
                        }
                        that.choosedPics = that.item.smallPictureUrls.concat();
                        that.item.smallPictureUrls.push(that.item.mainPictureUrl);
                        that.item.priceYuan = that.Common.toFix(that.item.price / 100)
                        if (that.item.sdljCount) {
                            that.item.sdljCountYuan = that.Common.toFix(that.item.sdljCountYuan / 100);
                        }
                        if (that.item.couponPrice) {
                            that.item.couponPriceYuan = that.Common.toFix(that.item.couponPrice / 100);
                        } else {
                            that.item.couponPriceYuan = 0;
                        }
                        if (that.item.perFace) {
                            that.item.perFaceYuan = that.Common.toFix(that.item.perFace / 100) + "";
                        } else {
                            that.item.perFaceYuan = null;
                        }
                    }
                }, function (res) {
                    that.failMsg(res.msg)
                }
            )
        },

        choosePic(value) {
            console.log(value)
        },

        addPic() {
            this.choosedPics.push(this.newAddedPicUrl);
            if (!this.item.smallPictureUrls) {
                this.item.smallPictureUrls = []
            }
            this.item.smallPictureUrls.push(this.newAddedPicUrl);
            this.newAddedPicUrl = null
            this.$forceUpdate()
        },
        goToDetail(product) {
            if (product.openProductType == 'TMALL' || product.openProductType == 'TAOBAO') {
                if (product.fullId) {
                    window.open("https://uland.taobao.com/item/edetail?id=" + product.fullId, '_blank');
                } else {
                    window.open("https://item.taobao.com/item.htm?id=" + product.openId, '_blank');
                }
            } else if (product.openProductType == 'PDD') {
                window.open("https://jinbao.pinduoduo.com/goods-detail?s=" + product.openId.replace("PDD", ""), '_blank');
            } else if (product.openProductType == 'JD') {
                window.open("https://item.jd.com/" + product.openId.replace("JD", "") + '.html', '_blank');

            }
        },
        showNewPanel() {
            this.item = {}
            if (this.activeNames.length > 0) {
                this.activeNames = []
            } else {
                this.activeNames = ["1"]
            }
        },
        edit(product) {
            var that = this;
            if (product.price) {
                product.priceYuan = this.Common.toFix(product.price / 100);
            }
            if (product.couponPrice) {
                product.couponPriceYuan = this.Common.toFix(product.couponPrice / 100)
            }
            if (product.perFace) {
                product.perFaceYuan = this.Common.toFix(product.perFace / 100)
            }
            if (product.sdljCount) {
                product.sdljCountYuan = this.Common.toFix(product.sdljCount / 100)
            }
            this.keyword = this.detailUrl(product)
            this.taolijins = []
            this.item = product;
            this.choosedPics = JSON.parse(this.item.pictures)
            this.activeNames = ["1"]
            openProductApi.getOpenProduct.call(that, {
                    keyword: this.keyword,
                    containPics: true,
                    openProductType: product.openProductType
                }, function (res) {
                    if (res.result.item) {
                        that.item.smallPictureUrls = res.result.item.smallPictureUrls;
                        that.item.smallPictureUrls.push(res.result.item.mainPictureUrl)
                        that.item.openId = res.result.item.openId;
                        if (res.result.item.couponPrice) {
                            that.item.couponPrice = res.result.item.couponPrice
                            that.item.couponPriceYuan = that.Common.toFix(res.result.item.couponPrice / 100);
                        }

                        if (res.result.item.price) {
                            that.item.price = res.result.item.price
                            that.item.priceYuan = that.Common.toFix(res.result.item.price / 100);
                        }

                        if (res.result.item.commissionRate) {
                            that.item.commissionRate = res.result.item.commissionRate
                        }

                        if (res.result.item.monthCount) {
                            that.item.monthCount = res.result.item.monthCount
                        }


                        let length = that.choosedPics.length;
                        var newAddedPics = []
                        for (let i = 0; i < length; i++) {
                            let choosedPic = that.choosedPics[i];
                            var hasContain = false;
                            for (let j = 0; j < that.item.smallPictureUrls.length; j++) {
                                if (choosedPic == that.item.smallPictureUrls[j]) {
                                    hasContain = true;
                                    break
                                }
                            }
                            if (!hasContain) {
                                newAddedPics.push(choosedPic)
                            }
                        }
                        //that.item.introduce = res.result.item.introduce
                        that.item.smallPictureUrls = that.item.smallPictureUrls.concat(newAddedPics)
                        that.$forceUpdate();
                    }
                }, function (res) {
                    that.failMsg(res.msg)
                }
            );
            this.loadTaolijins();

        },
        change() {
            this.$forceUpdate();
        },
        moveUp(product, index) {
            var that = this
            if (index - 1 >= 0) {
                that.loading = true
                var indexItem = that.items[index]
                var lastItem = that.items[index - 1]
                var indexSort = indexItem.sort
                var lastSort = lastItem.sort
                lastItem.sort = indexSort;
                indexItem.sort = lastSort;
                userProductApi.createOrUpdateUserProduct.call(that, lastItem, function (res) {
                    userProductApi.createOrUpdateUserProduct.call(that, indexItem, function (res) {
                        that.loading = false
                        that.items[index] = lastItem
                        that.items[index - 1] = indexItem
                    }, function (res) {
                        that.loading = false
                    })
                }, function (res) {
                    that.loading = false;
                })
            } else {
                that.failMsg("已经是第一个了")
            }
        },

        movePicUp(product, index) {
            var that = this
            if (index - 1 >= 0) {
                var indexItem = product.smallPictureUrls[index]
                var lastItem = product.smallPictureUrls[index - 1]
                product.smallPictureUrls[index] = lastItem
                product.smallPictureUrls[index - 1] = indexItem
                that.$forceUpdate();
            } else {
                that.failMsg("已经是第一个了")
            }
            console.log(that.choosedPics)
        },
        toTop(product, index) {
            var that = this
            that.loading = true
            userProductApi.getUserProducts.call(that, {
                    categoryId: that.currentSelect,
                    page: 1,
                    pageSize: that.pageSize
                },
                function (res) {
                    if (res.result.items && res.result.items.length > 0) {
                        var sort = res.result.items[0].sort - 1;
                        let indexItem = that.items[index];
                        indexItem.sort = sort;
                        userProductApi.createOrUpdateUserProduct.call(that, indexItem, function (res) {
                            that.items.splice(index, 1)
                            that.items.splice(0, 0, indexItem)
                            that.loading = false
                        }, function (res) {
                            that.loading = false
                            that.failMsg("操作失败，请重试！");
                        })

                    }
                },
                function (res) {
                    that.loading = false
                    that.failMsg("操作失败，请重试");
                }
            )

        },
        toPicTop(product, index) {
            let indexItem = product.smallPictureUrls[index];
            product.smallPictureUrls.splice(index, 1)
            product.smallPictureUrls.splice(0, 0, indexItem)
            this.$forceUpdate()
        },
        moveDown(product, index) {

        },
        deleteProduct(product, index) {
            var that = this;
            userProductApi.deleteUserProduct.call(that, {id: product.id}, function (res) {
                that.items.splice(index, 1)
            })
        },
        initRule(rebateRules) {


        },
        addRule(index) {
            if (this.item.rules.length >= this.maxRules) {
                this.failMsg("最大支持" + this.maxRules + "个规则");
                return;
            }
            this.item.rules.splice(index + 1, 0, {
                text: ''
            });
        },
        deleteRule(index) {
            this.item.rules.splice(index, 1)
        },
        onSubmit(formName) {
            var that = this
            console.log(this.item.introduce)
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (!that.currentSelect) {
                        that.failMsg("请选择专题");
                        return
                    }
                    if (that.item.introduce && that.item.introduce.length > 200) {
                        that.failMsg("简介不要超过200个字");
                        return
                    }

                    that.item.categoryId = that.currentSelect;
                    that.item.price = that.item.priceYuan * 100
                    if (that.item.sdljCountYuan) {
                        that.item.sdljCount = that.item.sdljCountYuan * 100;
                    }
                    that.item.couponPrice = that.item.couponPriceYuan * 100
                    if (!that.item.sort) {
                        that.item.sort = that.totalCount + 1;
                    }
                    console.log(that.item)
                    let picLength = that.item.smallPictureUrls.length;
                    var sortedChoosedPics = []
                    for (let i = 0; i < picLength; i++) {
                        let pic = that.item.smallPictureUrls[i];
                        for (let j = 0; j < that.choosedPics.length; j++) {
                            if (pic == that.choosedPics[j]) {
                                sortedChoosedPics.push(pic)
                                break
                            }
                        }
                    }
                    if (sortedChoosedPics.length > 0) {
                        that.item.mainPictureUrl = sortedChoosedPics[0];
                    }
                    that.item.pictures = JSON.stringify(sortedChoosedPics)
                    //that.item.introduce = that.item.introduce.replace(/(\r\n)|(\n)/g,"<br>")
                    userProductApi.createOrUpdateUserProduct.call(that, that.item, function (res) {
                        if (res.result.item && !that.item.id) {
                            that.items.push(res.result.item)
                            that.totalCount = that.totalCount + 1
                        }
                        that.successMsg(res.msg)
                    });
                } else {
                    return false;
                }
            })

        },
        handleCurrentChange() {
            var that = this;
            userProductApi.getUserProducts.call(that, {
                categoryId: that.currentSelect,
                page: that.page,
                pageSize: that.pageSize
            }, function (res) {
                if (res.result.items) {
                    that.items = res.result.items;
                }
                if (res.result.totalCount) {
                    that.totalCount = res.result.totalCount
                }
            })
        }
    }
}

</script>
<style lang="scss">

.user-products {

    .el-collapse{
        width: 100%;
    }
    .el-button{
        height: 100%;
    }
    .group:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }

  .iconfont {
    color: #ff0036;
    font-size: 25px;
  }

  .opt-area {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;

    button {
      float: right;
    }
  }


  .product-detail .detail-box {
    display: flex;
    justify-content: space-around;
    align-items: center;
    text-align: center;
    margin-top: 5px;
    background-image: linear-gradient(to right, #fc603d, #FF0036);
    color: #fff;
    padding: 5px 0;
    border-radius: 5px;
  }

  .product-detail .detail-box .text {
    color: #faef57;
    font-size: 13px;
    font-weight: 500;
  }

  .product-detail .detail-box .tag {
    font-size: 13px;
  }

  .product-detail .time-buys {
    position: fixed;
    left: 15px;
    top: 30px;
    height: 40px;
    width: 100%;
    z-index: 99999;
  }


  .product-detail .time-buys .swiper {
    height: 100px;
  }


  .product-detail .time-buy {
    background-color: #000;
    opacity: 0.7;
    font-size: 15px;
    color: #FFFFFF;
    padding: 10px 20px;
    border-radius: 40px;
    max-width: 50%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .product-detail .time-buy .head-img {
    width: 40px;
    height: 40px;
    margin-right: 15px;
  }

  .product-detail .time-buy .item {
    display: inline-block;
    vertical-align: middle;
  }

  .product-detail .coupon-tip {
    position: fixed;
    width: 80%;
    top: 200px;
    color: #000000;
    font-size: 13px;
    z-index: 999999;
    margin: 0 10%;
    text-align: center;
  }

  .product-detail .coupon-tip .coupon-title {
    height: 80px;
    background-image: linear-gradient(to right, #fc603d, #FF0036);
    color: white;
    line-height: 80px;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
  }

  .product-detail .coupon-tip .coupon-body {
    background-color: #fff;
    width: 100%;
  }

  .product-detail .coupon-tip .tao-token {
    height: 60px;
    line-height: 60px;
    display: block;
    width: 60%;
    margin: 0px auto;
    border-radius: 10px;
    border: 1px dashed #ff0036;
    font-size: 30px;
  }

  .product-detail .coupon-tip .tip-title {
    color: #ff0036;
    font-size: 30px;
    font-weight: 500;
    padding: 20px 0;
  }

  .product-detail .coupon-tip .tip {
    color: #333;
    font-size: 30px;
    padding: 20px 0;
  }

  .product-detail .coupon-tip .close {
    width: 60px;
    height: 60px;
    margin-top: 30px;
  }


  .product-detail .product-pics {
    width: 100%;
    height: 100%;
    overflow: hidden;
    text-align: center;
    background-color: #fff;
    padding: 50% 0;
    position: relative;
  }


  .product-detail .product-pics .operation {
    display: none;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  .product-detail .product-pics:hover {
    cursor: pointer;
  }

  .product-detail .product-pics .operation {
    display: flex;
    justify-content: space-around;
  }

  .product-detail .product-pics .operation .item {
    box-sizing: border-box;
    width: 20%;
  }

  .product-detail .float-price {
    position: absolute;
    top: 15px;
    right: 15px;
    background-color: transparent;
    color: #fff;
  }

  .product-detail .float-price .float-item {
    margin: 15px 0;
    padding: 0 15px;
    background-image: -webkit-linear-gradient(left, #f09938, #f09938);
    background-image: -o-linear-gradient(left, #f09938, #f09938);
    background-image: linear-gradient(to right, #f09938, #f09938);
    border-radius: 12px 0;
    height: 60px;
    font-size: 13px;
    line-height: 60px;
    text-align: left;
    display: block;
  }

  .product-detail .switch {
    width: 100%;
    text-align: center;
    background-color: #fff;
    position: relative;
  }

  .product-detail .switch .item {
    width: 80px;
    text-align: center;
    background-color: #fff;
    position: relative;
    color: #555555;
    display: inline-block;
    margin: 5px 10px;
    border-radius: 22px;
    font-size: 22px;
    padding: 5px 10px;
    background-color: #b3b2b3;
  }

  .product-detail .switch .item .video {
    width: 18px;
    height: 18px;
    vertical-align: middle;
  }

  .product-detail .switch .active {
    background-color: #FF0036;
    color: #fff;
  }

  .product-detail .switch {
    width: 100%;
    text-align: center;
    background-color: #fff;
    position: relative;
  }

  .product-detail .show-video {
    background-color: black;
  }

  .product-detail .swiper-h {
    width: 100%;
    text-align: center;
    background-color: #fff;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
  }

  .product-detail .product-video {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  .product-detail .pic-list {
    height: 100%;
  }

  .product-detail .product-pic {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  .product-detail .video-icon {
    width: 80px;
    height: 80px;
    position: absolute;
    left: 45%;
    top: 45%;
  }

  .product-detail .share .share-img {
    background-color: #FF0036;
    position: fixed;
    right: 0px;
    top: 100px;
    height: 60px;
    font-size: 13px;
    color: white;
    line-height: 60px;
    width: 150px;
    opacity: 0.7;
    z-index: 9999;
    padding: 0 5px;
  }

  .product-detail .share .share-btn {
    background-color: #FF0036;
    position: fixed;
    right: 0px;
    top: 260px;
    height: 60px;
    font-size: 13px;
    color: white;
    line-height: 60px;
    width: 150px;
    opacity: 0.7;
    z-index: 9999;
    padding: 0 5px;

  }

  .product-detail .detail-info {
    background-color: #fff;
    position: relative;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }

  .product-detail .detail-info .title-box {
    width: 100%;
    box-sizing: border-box;
  }

  .product-detail .from {
    float: left;
    background-color: red;
    font-size: 15px;
    border-radius: 5px;
    width: 36px;
    height: 36px;
    padding: 5px 5px;
    text-align: center;
  }

  .product-detail .h1 {
    font-size: 13px;
    line-height: 25px;
    height: 25px;
    color: #363b41;
    background-color: #fff;
    box-sizing: border-box;
    word-break: break-all;
  }

  .product-detail .h1 span {
  }

  .product-detail .h1 image {
    position: relative;
    top: -5px;
    width: 45px;
    height: 45px;
    vertical-align: middle;
  }

  .product-detail .product-title {
    font-size: 36px;
    box-sizing: border-box;
  }

  .product-detail .detail-info .product-price {
    height: 25px;
    line-height: 25px;
  }

  .product-detail .detail-info .product-sub-info {
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    font-size: 22px;
    color: #828282;
    font-weight: 300;
    margin: 10px 0;
  }

  .product-detail .detail-info .price-tag,
  .product-detail .detail-info .reserve-price-tag,
  .product-detail .detail-info .price,
  .product-detail .detail-info .reserve-price,
  .product-detail .detail-info .product-good-rate,
  .product-detail .detail-info .sale-count {
    display: inline-block;
  }

  .product-detail .detail-info .product-good-rate {
    margin-left: 15px;
  }

  .product-detail .detail-info .product-good-rate .name {
    display: inline-block;
    font-size: 18px;
  }

  .product-detail .detail-info .product-good-rate .value {
    display: inline-block;
    font-size: 22px;
    margin-left: 5px;
  }

  .product-detail .product-price .sale-count {
    float: right;
    font-size: 15px;
    color: #999;
    margin-right: 10px;
  }

  .product-detail .product-price .rebate-sale-count {
    float: none;
    margin-left: 5px;
  }

  .product-detail .product-price .price {
    color: red;
    margin-left: 5px;
    font-weight: bold;
  }

  .product-detail .reserve-price {
    margin-left: 15px;
    font-size: 15px;
    color: #999;
    text-decoration: line-through;
  }

  .product-detail .price {
    font-size: 15px;
    font-weight: 400;
  }

  .product-detail .price-tag {
    background-color: #FF0036;
    border-radius: 5px 0;
    font-size: 12px;
    height: 20px;
    line-height: 20px;
    padding: 0px 5px;
    color: #fff;
  }

  .product-detail .reserve-price-tag {
    background-color: #ddd;
    border-radius: 5px 0;
    font-size: 12px;
    height: 20px;
    line-height: 20px;
    padding: 0px 5px;
    margin-left: 5px;
  }

  .product-detail .rebate-price {
    float: right;
    margin-right: 10px;
  }

  .product-detail .rebate-price .price-tag {
    color: #faef57;
  }

  .product-detail .coupon-box {
    width: 100%;
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 9999;
    background-color: #fff;
  }

  .product-detail .coupon-box .coupon-info {
    width: 60%;
    height: 90px;
    line-height: 90px;
    padding: 0 10px;
    box-sizing: border-box;
    display: inline-block;
    float: right;
    position: relative;
  }

  .product-detail .coupon-box .nav-mini-app {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 90px;
    background-color: transparent;
  }

  .product-detail .coupon-box .nav-mini-app-left {
    position: absolute;
    left: 0;
    top: 0;
    width: 50%;
    height: 90px;
    background-color: transparent;
  }

  .product-detail .coupon-box .price-info {
    display: inline-block;
    width: 50%;
    color: #fff;
    text-align: center;
    height: 70px;
    line-height: 70px;
    font-weight: 400;
    font-size: 13px;
    background-image: linear-gradient(to right, #f09938, #f09938);
    position: relative;
    vertical-align: middle;
    border-top-left-radius: 55px;
    border-bottom-left-radius: 55px;
    box-sizing: border-box;
  }

  .product-detail .coupon-box .price-info .price-detail {
    width: 100%;
    box-sizing: border-box;
  }

  .product-detail .coupon-box .operate {
    position: relative;
    left: 0;
    top: 0;
    height: 90px;
    width: 40%;
    display: inline-block;
    float: left;
  }

  .product-detail .coupon-box .operate .share {
    width: 50px;
    height: 50px;
    vertical-align: middle;
    display: inline-block;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
  }

  .product-detail .coupon-box .operate .item {
    width: 50px;
    height: 90px;
    display: inline-block;
    margin-left: 30px;
    position: relative;
    text-align: center;
    padding: 10px 0;

  }

  .product-detail .coupon-box .operate .item .icon {
    width: 45px;
    height: 45px;
    display: inline-block;

  }

  .product-detail .coupon-box .operate .item .text {
    font-size: 15px;
    margin-top: -10px;
    color: #999;
  }

  .product-detail .coupon-box .operate .share-bg {
    position: relative;
  }

  .product-detail .coupon-box .not-show {
    position: absolute;
    z-index: 100000;
    top: 30%;

  }

  .product-detail .coupon-box .price {
    display: inline-block;
    box-sizing: border-box;
    font-size: 13px;
  }

  .product-detail .coupon-box .reserve-price {
    display: inline-block;
    color: #fff;
  }

  .product-detail .rebate-info .reserve-price {
    text-decoration: none;
    margin-left: 0;
  }

  .product-detail .get-coupon {
    background-image: linear-gradient(to right, #fc603d, #FF0036);
    display: inline-block;
    width: 50%;
    height: 70px;
    line-height: 70px;
    text-align: center;
    color: #fff;
    box-sizing: border-box;
    font-size: 13px;
    vertical-align: middle;
    border-top-right-radius: 55px;
    border-bottom-right-radius: 55px;
    position: relative;
  }

  .product-detail .get-coupon {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    padding: 0;
  }

  .product-detail .get-coupon-not-start {
    background-image: linear-gradient(to right, #b2a8a8, #bab4b4);
  }

  .product-detail .recommend {
    margin: 10px 0 0 0;
    background-color: #fff;
    font-size: 14px;
    position: relative;
    width: 100%;
    box-sizing: border-box;
  }

  .product-detail .recommend .tag {
    border: 1px solid red;
    text-align: center;
    padding: 0 5px;
    border-radius: 8px 0;
    display: inline-block;
    position: absolute;
    color: red;
    margin-left: 5px;
  }

  .product-detail .recommend .word {
    padding: 5px 10px;
    width: 100%;
    box-sizing: border-box;
    height: 65px;
    color: #828282;
    font-weight: 300;
    display: inline-block;
    max-height: 65px;
    overflow: hidden;
    line-height: 20px;
    background-color: #f2f2f2;
    border-radius: 5px;

  }

  .product-detail .rate-box {
    background-color: #fff;
    color: #363b41;
    font-size: 13px;

  }

  .product-detail .rate-box .rate-item {
    padding: 0 10px;

  }

  .product-detail .rate-box .rate-count {
    font-size: 13px;
  }

  .product-detail .rate-box .rate-user-headpic {
    width: 40px;
    height: 40px;
    line-height: 20px;
    vertical-align: middle;
    margin: 0 10px;
  }

  .product-detail .rate-box .rate-user-name {
    height: 40px;
    line-height: 20px;
    vertical-align: middle;
  }

  .product-detail .rate-box .rate-feedback {
    font-size: 23px;
  }

  .product-detail .rate-box .rate-subinfo {
    font-size: 15px;
    color: #999;
  }

  .product-detail .rate-box .all-rate {
    width: 180px;
    text-align: center;
    margin: 15px auto;
    color: #FF0036;
    border: 1px solid #FF0036;
    border-radius: 20px;
  }

  .product-detail .shop-info {
    margin: 15px 0;
    background-color: #fff;
    font-size: 22px;
    padding: 10px;
    width: 100%;
    box-sizing: border-box;
    text-align: center;
  }

  .product-detail .shop-main {
    width: 100%;
    height: 120px;
    margin: 5px 10px;
    padding: auto 0;
  }

  .product-detail .shop-info-pdd .shop-main {
    height: auto;
  }

  .product-detail .shop-info .shop-logo {
    width: 100px;
    height: 100px;
    float: left;
    border-radius: 10px;
  }

  .product-detail .shop-info .shop-rate {
    float: left;
    margin-left: 30px;
  }

  .product-detail .shop-info .shop-rate .shop-name {
    font-size: 13px;
    margin-bottom: 20px;
    color: #555;
  }

  .product-detail .shop-info-pdd .shop-name {
    margin-top: 30px;
  }

  .product-detail .shop-info .shop-rate .name,
  .product-detail .shop-info .shop-rate .value {
    float: left;
    margin-right: 10px;
  }

  .product-detail .shop-info .shop-rate .value {
    font-size: 13px;
  }

  .product-detail .shop-sub {
    width: 100%;
  }

  .product-detail .shop-sub-item {
    width: 33.3%;
    box-sizing: border-box;
    font-size: 13px;
    text-align: center;
    margin: 10px 0;
    float: left;
  }

  .product-detail .shop-sub-item .name, .product-detail .shop-sub-item .value {
    text-align: center;
    margin: 10px auto;
  }

  .product-detail .name {
    color: #999;
    font-weight: 300;
  }

  .product-detail .value {
    color: #999;
  }

  .product-detail .shop-sub .all-count,
  .product-detail .shop-sub .fans-count {
    border-right: 1px solid #ddd;
  }

  .product-detail .shop-info .shopdsr {
    width: 100%;
  }

  .product-detail .shop-info .dsrname,
  .product-detail .shop-info .score,
  .product-detail .shop-info .dsr-tag {
    display: inline-block;
    line-height: 30px;
  }

  .product-detail .shop-info .dsr-tag {
    border-radius: 5px;
    margin-left: 5px;
    font-size: 15px;
  }

  .product-detail .shop-info .score {
    margin-left: 5px;
  }

  .product-detail .shop-info .dsrname {
    color: #999;
  }

  .product-detail .low {
    color: #00b78b;
  }

  .product-detail .high, .product-detail .equal {
    color: #e13e4c;
  }

  .product-detail .detail-desc {
    width: 100%;
    text-align: center;
    font-size: 13px;
    margin-top: 10px;
  }

  .product-detail .detail-desc .placeholder-show {
    width: 100%;
    height: 300px;
  }

  .product-detail .detail-desc .placeholder-hidden {
    display: none;
  }

  .product-detail .title {
    margin: 10px auto;
    width: 100%;
    border-right: 5px;
    color: #b3b3aa;
    font-size: 13px;
    padding: 10px;
    text-align: center;
    background-color: #f2f2f2;
  }

  .product-detail .detail-desc .desc-pic {
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .product-detail .coupon-big-box {
    background-color: #fff;
    height: 60px;
    line-height: 60px;
    color: #fff;
    font-size: 20px;
    margin: 5px 0;
    position: relative;
  }


  .product-detail .coupon-big-box .main {
    position: relative;
    width: 90%;
    height: 60px;
    line-height: 60px;
    margin: 0px auto;
    background-image: linear-gradient(to right, #fc603d, #FF0036);

  }

  .product-detail .coupon-big-box .nav-mini-app {
    position: absolute;
    left: 5%;
    top: 0;
    width: 90%;
    height: 130px;
    line-height: 130px;
    margin: 0px auto;
    background-color: transparent;
  }

  .product-detail .coupon-big-box .item {
    display: inline-block;
    width: 50%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    box-sizing: border-box;
    margin-top: 5px;

  }

  .product-detail .coupon-big-box .left {
    width: 60%;
    border-right: 2px dashed #fff;
  }

  .product-detail .coupon-big-box .right {
    width: 40%;
  }

  .product-detail .coupon-big-box .right .coupon-btn {
    background-color: #faef57;
    padding: 5px 25px;
    border-radius: 35px;
    color: #555;
    line-height: 60px;
  }

  .product-detail .coupon-big-box .right .coupon-btn {
    width: 80%;
    margin: 0 auto;
  }

  .product-detail .coupon-big-box .rebate-btn .price-tag {
    display: inline-block;
    padding: 0px;
  }

  .product-detail .coupon-big-box .rebate-btn .price {
    display: inline-block;
  }

  .product-detail .coupon-big-box .left-round {
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 20px;
    background-color: #fff;
    left: -10px;
    top: 20px;
  }

  .product-detail .coupon-big-box .right-round {
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 20px;
    background-color: #fff;
    right: -10px;
    top: 20px;
  }

  .product-detail .multi-fun {
    width: 160px;
    position: fixed;
    bottom: 400px;
    right: 20px;
    z-index: 100000;
  }

  .product-detail .multi-fun .fun-item {
    height: 80px;
    font-size: 14px;
    color: #fff;
    position: relative;
  }

  .product-detail .multi-fun .fun-item .item-icon {
    width: 65px;
    height: 65px;
    float: right;
    position: relative;
  }

  .product-detail .multi-fun .fun-item .item-name {
    width: 65px;
    height: 65px;
    vertical-align: middle;
    float: left;
    margin-left: 15px;
    line-height: 65px;
  }

  .product-detail .multi-btn {
    width: 70px;
    height: 70px;
    position: fixed;
    bottom: 390px;
    right: 20px;
    z-index: 10000;
  }

  .product-detail .bg-pic {
    width: 100%;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 99999;
  }

  .product-detail .multi-fun .share {
    width: 80px;
    height: 80px;
    vertical-align: middle;
    display: inline-block;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
  }

  .product-detail .props-panel {
    position: fixed;
    right: 0;
    bottom: 90px;
    background-color: #fff;
    z-index: 100000;
    width: 100%;
    height: 80%;
    color: #555555;
    border-top-right-radius: 30px;
    border-top-left-radius: 30px;
    overflow: hidden;
  }

  .product-detail .prop {
    border-bottom: 1px solid #eeeeee;
    font-size: 13px;
    min-height: 70px;
    max-height: 140px;
    overflow: hidden;
    line-height: 70px;
    padding: 10px 20px;
  }

  .product-detail .props-panel .title {
    text-align: center;
    font-size: 13px;
    background-color: #fff;
    color: #555555;
    width: 80%;
  }

  .product-detail .props-panel .name {
    width: 30%;
    display: inline-block;
    box-sizing: border-box;
    vertical-align: middle;
    color: #999999;

  }

  .product-detail .props-panel .value {
    width: 70%;
    vertical-align: middle;
    display: inline-block;
    box-sizing: border-box;
    color: #555555;

  }

  .product-detail .scroll-props {
    white-space: nowrap;
    width: 100%;
    height: 90%;
  }

  .product-detail .finish-panel {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 90px;
    color: #fff;
    background-color: #fff;
    z-index: 999999;
  }

  .product-detail .finish-panel .finish-btn {
    height: 70px;
    border-radius: 70px;
    position: absolute;
    bottom: 10px;
    margin: 0 5%;
    color: #fff;
    font-size: 13px;
    width: 90%;
    line-height: 70px;
    text-align: center;
    background-image: linear-gradient(to right, #FF0036, #FF0036);
  }

  .product-detail .bg-props {
    width: 100%;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 100000;
  }

  .product-detail .share-panel {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 9999;
    background-color: #fff;
    height: 100vh;
  }

  .product-detail .share-panel .product-info {
    position: relative;
  }

  .product-detail .share-panel .product-pics {
    width: 60%;
    padding: 30% 0;
    display: inline-block;
    box-sizing: border-box;
  }

  .product-detail .share-panel .product-desc {
    width: 40%;
    display: inline-block;
    background-color: #fff;
    font-size: 13px;
    vertical-align: top;
    margin-top: 10px;
    box-sizing: border-box;
  }

  .product-detail .share-panel .price-tag {
    display: inline-block;
    margin-left: 5px;
    font-size: 30px;
    height: 40px;
    line-height: 20px;

  }

  .product-detail .share-panel .price {
    font-size: 60px;
    display: inline-block;
    color: #FF0036;
  }

  .product-detail .share-panel .reserve-price {
    font-size: 13px;
  }

  .product-detail .coupon-bg-price {
    font-size: 20px;
    color: #faef57;
    font-weight: bold;
  }

  .product-detail .share-panel .h1 {
    margin-bottom: 20px;
    line-height: 20px;
    font-size: 30px;
    max-height: 210px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .product-detail .share-panel .price-info {
    position: absolute;
    bottom: 10px;
  }

  .product-detail .first-guide {
    position: fixed;
    bottom: 90px;
    left: 10px;
    height: 70px;
    z-index: 99999;
    font-size: 13px;
    color: #fff;
  }

  .product-detail .first-guide .text {
    line-height: 60px;
    height: 60px;
    text-align: center;
    background-color: #000;
    opacity: 0.8;
    width: 250px;
    border-radius: 15px;
  }

  .product-detail .first-guide .arrow {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 15px 15px 0 15px;
    border-color: #000000 transparent transparent transparent;
    margin-left: 30px;
    opacity: 0.8;
  }

  .product-detail .h1 {
    overflow: hidden;
  }

  .product-detail .recommend .tag {
    position: relative;
    border-radius: 0;
    border: none;
    display: block;
  }


  .product-detail .recommend .person {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
  }

  .product-detail .recommend .person .person-info {
    flex: 1;
    padding: 0 10px 0 20px;

  }

  .product-detail .recommend .person .person-head {
    width: 80px;
    height: 80px;
    border-radius: 80px;
  }

  .product-detail .recommend .person .person-name {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .product-detail .recommend .person .person-name span {
    color: #363636;
    font-weight: 600;
  }

  .product-detail .recommend .person .person-tag {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .product-detail .recommend .person .person-tag span {
    color: #ff8400;
    background-color: rgba(254, 127, 0, .1);
    margin: 10px 10px 10px 0;
    padding: 10px;
    border-radius: 10px;
  }


  .product-detail .recommend .person .person-wechat {
    display: flex;
    align-items: center;
    color: #77d034;
    border: 2px solid #77d034;
    padding: 10px;
    border-radius: 10px;
  }

  .product-detail .recommend .person .person-wechat .wechat {
    color: #77d034;
    font-weight: normal;
  }


  .product-detail .recommend .person .person-wechat .wechat-img {
    width: 30px;
    height: 30px;
  }

  .product-detail .recommend .person .person-wechat .wechat-icon-big {
    width: 50px;
    height: 50px;
  }

  .product-detail .wechat-panel {
    background-image: url(http://web.bbaadd.cn/img/packet.fc0b7f0b.png);
    width: 100%;
    background-repeat: no-repeat;
    background-size: 100%;
    height: 1000px;
    position: fixed;
    left: 0;
    top: 50px;
    margin: 0 auto;
    text-align: center;
    z-index: 100000;
  }


  .product-detail .wechat-panel .csInfo-text {
    width: 100%;
    height: 350px;
    margin-top: 200px;
    position: relative;
  }

  .product-detail .wechat-panel .csInfo-image {

  }

  .product-detail .wechat-panel .csInfo-image p,
  .product-detail .wechat-panel .csInfo-text p {
    font-size: 13px;
    color: #fff;
    padding-top: 15px;
    display: block;

  }

  .product-detail .wechat-panel .csInfo-qrcode {
    width: 200px;
    height: 200px;
    border-radius: 10px;
    display: block;
    margin: 0 auto;

  }

  .product-detail .wechat-panel .csInfo-thumbnail {
    margin: 300px auto 0 auto;
    width: 200px;
  }

  .product-detail .wechat-panel .csInfo-thumbnail image {
    width: 100px;
    height: 100px;
    border-radius: 100px;
    display: block;
    margin: 0 auto;

  }

  .product-detail .wechat-panel .csInfo-text .cs-tag {
    border: 1px solid #fff;
    border-radius: 10px;
    font-size: 13px;
    text-align: center;
    position: absolute;
    padding: 5px 10px;
    color: #FFF;
  }

  .product-detail .wechat-panel .csInfo-close {
    width: 100%;
  }

  .product-detail .wechat-panel .csInfo-close image {
    width: 80px;
    height: 80px;
    margin: 60px auto 0 auto;
  }

  .cs-tag-0 {
    left: 200px;
    top: -50px
  }

  .cs-tag-1 {
    left: 120px;
    top: 50px;
  }

  .cs-tag-2 {
    left: 130px;
    top: 140px;

  }

  .cs-tag-3 {
    right: 200px;
    top: -50px;
  }

  .cs-tag-4 {
    right: 120px;
    top: 50px;

  }

  .cs-tag-5 {
    right: 130px;
    top: 140px;

  }


  .product-detail {
    width: 95%;
    margin: 5px auto;
    border-radius: 20px;
    padding: 5px;
    background-color: #fff;
  }

  .product-detail .recommend {
    margin-bottom: 5px;
  }

  text-align: left;

  .rules {
    margin-bottom: 10px;
  }

  .line {
    text-align: center;
  }


  .opt {
    margin-left: 5px;
  }

  .head-tip {
    margin-left: 5px;
    color: #ff0036;
  }

  .tip {
    color: #409EFF;
    font-weight: 500;
  }


  .title {
    display: flex;
    align-items: center;
    width: 100%;

    .trigger {
      margin-left: 20px;
    }

    strong {
      color: $hover-color;
    }

  }

  .el-collapse {
    border: none;
  }

  .el-collapse-item__wrap {
    border: none;
  }


  .el-collapse-item__content {
    padding-bottom: 0px;
  }

  .pic-item-4 {
    width: 25%;
    float: left;
    box-sizing: border-box;
    position: relative;
    text-align: center;


    .opt {
      display: flex;
      justify-content: space-between;
      margin-left: 0;

      .btn-item {
        width: 50%
      }
    }

    .pic-item-box {
      width: 98%;
      padding-bottom: 98%;
      margin: 0 auto;
      height: 0;
      position: relative;
      text-align: center;


      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 4px;
        position: absolute;
        top: 0;
        left: 0;
      }
    }


  }

  .cell-item-img {
    height: 50px;
    line-height: 50px;
    text-align: left;
    display: flex;
  }

  .media-image {
    width: 50px;
    height: 50px;
  }

  .reflection {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 2;
    left: 0;
    top: 0;
    transition: all 0.1s ease;
    opacity: 0;
    mix-blend-mode: soft-light;
  }

  .el-table .cell {
    white-space: nowrap;
    word-break: keep-all;
    text-overflow: unset;
  }

  .operation .opt-item {
    margin: 5px;
  }

  .operation button {
  }

  .alter-text {
    height: 20px;
    line-height: 20px;

    .warning {
      color: #ff0036;
      font-weight: bold;
    }
  }

  .el-table--striped .el-table__body tr.el-table__row--striped.current-row td, .el-table__body tr.current-row > td {
    color: #fff;
    background-color: #a2a4a7 !important;
  }

  .product-cell {
    float: left;
  }
}

</style>